import { defineRule } from 'vee-validate'
import {
  alpha,
  alpha_num as alphaNum,
  between,
  confirmed,
  digits,
  email,
  integer,
  max,
  min,
  numeric,
  required,
  url
} from '@vee-validate/rules'

/* The standard rule set. These return booleans rather than message strings, so
   the message is produced by `generateMessage` (see plugins/vee-validate.js) and
   looked up by rule name - which is what lets the `validation.*` entries in the
   locale catalogues take effect and switch language with the app. */
const standardRules = {
  required,
  email,
  min,
  max,
  confirmed,
  numeric,
  alpha,
  alpha_num: alphaNum,
  integer,
  between,
  digits,
  url
}

Object.entries(standardRules).forEach(([name, rule]) => defineRule(name, rule))

/* True only for a date that actually exists. `new Date('2025-02-31')` rolls over
   to March 3rd rather than failing, so a plain parse would accept impossible
   dates. */
const isRealDate = (year, month, day) => {
  const date = new Date(Date.UTC(year, month - 1, day))

  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day
}

/* vee-validate 4 dropped the date rules, so this one stays local. */
defineRule('date_format', (value, params) => {
  if (value === null || value === undefined || value === '') return true

  const format = Array.isArray(params) ? params[0] : params.format

  switch (format) {
    case 'yyyy-mm-dd': {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false
      const [year, month, day] = value.split('-').map(Number)
      return isRealDate(year, month, day)
    }

    case 'mm/dd/yyyy': {
      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return false
      const [month, day, year] = value.split('/').map(Number)
      return isRealDate(year, month, day)
    }

    case 'dd/mm/yyyy': {
      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return false
      const [day, month, year] = value.split('/').map(Number)
      return isRealDate(year, month, day)
    }

    default:
      return !isNaN(new Date(value).getTime())
  }
})
